import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import GhgReport from "./GhgReport";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../context/AuthContext";

const Index = () => {
   const { user }= useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager ? <GroupAdminSidebar/> :<MainSidebar />}>
      <Unauthorized requiredModule="GHG Reports">
        <GhgReport />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Index;
